/// <reference types="./lustre.d.mts" />
import * as $dynamic from "../../gleam_stdlib/gleam/dynamic.mjs";
import * as $function from "../../gleam_stdlib/gleam/function.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $el from "../../lustre/lustre/element.mjs";
import * as $h from "../../lustre/lustre/element/html.mjs";
import * as $vnode from "../../lustre/lustre/vdom/vnode.mjs";
import * as $sketch from "../../sketch/sketch.mjs";
import {
  Ok,
  Error,
  toList,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
} from "../gleam.mjs";
import * as $css_stylesheet from "../sketch/lustre/internals/css_stylesheet.mjs";
import * as $global from "../sketch/lustre/internals/global.mjs";

const FILEPATH = "src/sketch/lustre.gleam";

class Document extends $CustomType {
  constructor(css_stylesheet) {
    super();
    this.css_stylesheet = css_stylesheet;
  }
}

class Shadow extends $CustomType {
  constructor(css_stylesheet) {
    super();
    this.css_stylesheet = css_stylesheet;
  }
}

class Node extends $CustomType {}

export function setup() {
  let $ = $sketch.stylesheet(new $sketch.Persistent());
  if ($ instanceof Ok) {
    let stylesheet = $[0];
    return $global.set_stylesheet(stylesheet);
  } else {
    return new Error(undefined);
  }
}

export function construct(init) {
  let $ = $sketch.stylesheet(new $sketch.Persistent());
  if ($ instanceof Ok) {
    let stylesheet = $[0];
    return $global.set_stylesheet(init(stylesheet));
  } else {
    return new Error(undefined);
  }
}

export function teardown(stylesheet) {
  return $result.map(
    $global.teardown_stylesheet(stylesheet),
    (_) => { return $sketch.dispose(stylesheet); },
  );
}

export function render(stylesheet, outputs, view) {
  let $ = $global.set_current_stylesheet(stylesheet);
  if (!($ instanceof Ok)) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "sketch/lustre",
      117,
      "render",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 3944,
        end: 4004,
        pattern_start: 3955,
        pattern_end: 3960
      }
    )
  }
  let new_view = view();
  let $1 = $global.get_stylesheet();
  if ($1 instanceof Ok) {
    let stylesheet$1 = $1[0];
    let content = $sketch.render(stylesheet$1);
    return $list.fold(
      outputs,
      new_view,
      (view, stylesheet) => {
        if (stylesheet instanceof Document) {
          let css_stylesheet = stylesheet.css_stylesheet;
          return $function.tap(
            view,
            (_) => {
              let $2 = $global.dismiss_current_stylesheet();
              
              return $css_stylesheet.replace(content, css_stylesheet);
            },
          );
        } else if (stylesheet instanceof Shadow) {
          let css_stylesheet = stylesheet.css_stylesheet;
          return $function.tap(
            view,
            (_) => {
              let $2 = $global.dismiss_current_stylesheet();
              
              return $css_stylesheet.replace(content, css_stylesheet);
            },
          );
        } else {
          return $el.fragment(toList([$h.style(toList([]), content), view]));
        }
      },
    );
  } else {
    return new_view;
  }
}

export function document() {
  let css_stylesheet = $css_stylesheet.create(new $css_stylesheet.Document());
  return new Document(css_stylesheet);
}

export function shadow(root) {
  let css_stylesheet = $css_stylesheet.create(
    new $css_stylesheet.ShadowRoot(root),
  );
  return new Shadow(css_stylesheet);
}

export function node() {
  return new Node();
}

function contains_head(el) {
  if (el instanceof $vnode.Element) {
    let $ = el.tag;
    if ($ === "head") {
      return true;
    } else {
      return $list.fold(
        el.children,
        false,
        (acc, val) => { return acc || contains_head(val); },
      );
    }
  } else {
    return false;
  }
}

function put_in_head(el, content) {
  if (el instanceof $vnode.Element) {
    let $ = el.tag;
    if ($ === "head") {
      let _record = el;
      return new $vnode.Element(
        _record.kind,
        _record.key,
        _record.mapper,
        _record.namespace,
        _record.tag,
        _record.attributes,
        (() => {
          let style = $h.style(toList([]), content);
          return listPrepend(style, el.children);
        })(),
        _record.keyed_children,
        _record.self_closing,
        _record.void,
      );
    } else if ($ === "html") {
      let _record = el;
      return new $vnode.Element(
        _record.kind,
        _record.key,
        _record.mapper,
        _record.namespace,
        _record.tag,
        _record.attributes,
        $list.map(
          el.children,
          (child) => { return put_in_head(child, content); },
        ),
        _record.keyed_children,
        _record.self_closing,
        _record.void,
      );
    } else {
      let node$1 = el;
      return node$1;
    }
  } else {
    let node$1 = el;
    return node$1;
  }
}

export function ssr(view) {
  let new_view = view();
  let $ = $global.get_stylesheet();
  if ($ instanceof Ok) {
    let stylesheet = $[0];
    let content = $sketch.render(stylesheet);
    let $1 = contains_head(new_view);
    if ($1) {
      return put_in_head(new_view, content);
    } else {
      return $el.fragment(toList([$h.style(toList([]), content), new_view]));
    }
  } else {
    return new_view;
  }
}
